<script setup lang="ts">
import type { TableSelectionState } from '@/hooks/useHybridlyTable';

import { ButtonColor, ButtonSize, ButtonVariant } from '@/hooks/useButtonClasses';
import Button from '@/components/button/Button.vue';
import Message from '@/icons/line/message.svg';

defineProps<{
  tableSelectionState: TableSelectionState;
}>();

const isSendingSms = ref(false);
const queryParameters = useQueryParameters();

function handleSendSms() {
  isSendingSms.value = true;
}
</script>

<template>
  <Button
    :color="ButtonColor.primary"
    :href="
      route('sms.compose', {
        ids: tableSelectionState.selectedRowIds || [],
        filters: queryParameters.filters || null,
        all: tableSelectionState.areAllRecordsSelected
      })
    "
    @click="handleSendSms"
    :iconLeft="Message"
    :size="ButtonSize.sm"
    :variant="ButtonVariant.solid"
    :isLoading="isSendingSms"
  >
    Send SMS
  </Button>
</template>
